import CustomApplicationCollection from './CustomApplicationCollection';

class CustomApplicationStore {
  collection = new CustomApplicationCollection();
}

export default new CustomApplicationStore();
